export const supportedLanguages = ['en', 'es'];
